export default __webpack_public_path__ + "52426ba7f0b3d2d6df99858dd94cfa91.svg";